import { createReducer, on } from '@ngrx/store';
import { initialState } from '../auth.state';

import * as actions from './logout.actions';
export const authLogoutReducer = createReducer(
  initialState,

  on(actions.ResponseSuccessAuthLogoutAction, (state) => initialState),
  on(actions.ResponseFailAuthLogoutAction, (state) => initialState),
  on(actions.RequestAuthLogoutAction, (state) => {
    return {
      ...state,
      loading: true,
      auth: null,
    };
  })
);
